import { useStore } from '@@/store/index.js'
import { storeToRefs } from 'pinia'

export const useArticlesByTag = (tag) => {
  const store = useStore()
  const { articles } = storeToRefs(store)

  const articlesByTag = articles.value.filter((a) => tag === '' || a.tag.slug === tag)
  const highlightedArticles = articlesByTag.filter(a => a.highlight)
  const restOfArticles = articlesByTag.filter(a => !a.highlight)
  return { articles: articlesByTag, highlightedArticles, restOfArticles }
}